// ===================================================
// CATÁLOGO DE ACABAMENTOS ESPECIAIS (rebaixo, friso,
// calha úmida, pia esculpida, peça especial) — usado
// como extra por peça na etapa Ambientes e peças do
// orçamento. Ver acabamentoAplicarCustoPeca() e
// atualizarCustosAutomaticosPedido() para o cálculo.
// ===================================================
const ACABAMENTO_CATEGORIAS={
  rebaixo:'Rebaixo', friso:'Friso', calha_umida:'Calha úmida',
  pia_esculpida:'Pia esculpida', peca_especial:'Peça especial'
};
// Categorias que oferecem "Aplicação" (onde o beneficiamento é executado na peça —
// frontal, superior, lateral etc.). Pia esculpida e peça especial não usam esse campo.
const ACABAMENTO_CATEGORIAS_COM_APLICACAO=['friso','rebaixo','calha_umida'];
const ACABAMENTO_APLICACOES=['Frontal','Traseira','Superior','Inferior','Lateral esquerda','Lateral direita','Interna','Externa','Abertura','Personalizada'];
const ACABAMENTO_TIPO_LABELS={
  rebaixo:{normal:'Normal',italiano:'Italiano',americano:'Americano',outro:'Outro'},
  peca_especial:{redonda:'Redonda',semicircular:'Semicircular',curva:'Curva',angulada:'Angulada',organica:'Orgânica',personalizada:'Personalizada'}
};
const ACABAMENTO_PIA_MODELO_LABELS={
  material_fabricacao_taxa:'Material + fabricação + taxa fixa', material_fabricacao_m2:'Material + fabricação + preço/m²',
  unidade:'Preço por unidade', metro_linear:'Preço por metro linear', combinado:'Combinação das regras'
};
function acabamentosCategoriaLabel(cat){return ACABAMENTO_CATEGORIAS[cat]||cat}
function acabamentoTipoLabel(categoria,tipo){return ACABAMENTO_TIPO_LABELS[categoria]?.[tipo]||tipo}
let _acabamentoImagemTemp=null;
let _acabamentoAplicacoesTemp=[];
function renderAcabamentoAplicacoesCheckboxes(selecionadas=[]){
  const host=document.getElementById('acabamento-aplicacoes-list');if(!host)return;
  host.innerHTML=ACABAMENTO_APLICACOES.map(op=>`<label style="display:flex;gap:5px;align-items:center;font-size:11.5px"><input type="checkbox" class="acabamento-aplicacao-chk" value="${escapeHtml(op)}" ${selecionadas.includes(op)?'checked':''}>${escapeHtml(op)}</label>`).join('');
}
function acabamentoAplicacoesSelecionadas(){
  return [...document.querySelectorAll('.acabamento-aplicacao-chk:checked')].map(el=>el.value);
}
function acabamentoAtualizarCamposCategoria(){
  const cat=document.getElementById('acabamento-categoria')?.value;
  const chapaWrap=document.getElementById('acabamento-chapa-extra-wrap');
  const piaAvisoWrap=document.getElementById('acabamento-pia-aviso');
  const precoGenericoWrap=document.getElementById('acabamento-precificacao-generica-wrap');
  const aplicacoesWrap=document.getElementById('acabamento-aplicacoes-wrap');
  const rebaixoWrap=document.getElementById('acabamento-detalhes-rebaixo');
  const calhaWrap=document.getElementById('acabamento-detalhes-calha');
  const piaDetalhesWrap=document.getElementById('acabamento-detalhes-pia');
  const peWrap=document.getElementById('acabamento-detalhes-peca-especial');
  // Preserva o que já estiver marcado antes de redesenhar a lista de aplicações
  // (senão alternar de categoria e voltar apaga a seleção do usuário).
  if(document.getElementById('acabamento-aplicacoes-list'))_acabamentoAplicacoesTemp=acabamentoAplicacoesSelecionadas();
  if(chapaWrap)chapaWrap.style.display=cat==='friso'?'':'none';
  if(piaAvisoWrap)piaAvisoWrap.style.display=cat==='pia_esculpida'?'':'none';
  if(precoGenericoWrap)precoGenericoWrap.style.display=cat==='pia_esculpida'?'none':'';
  if(aplicacoesWrap)aplicacoesWrap.style.display=ACABAMENTO_CATEGORIAS_COM_APLICACAO.includes(cat)?'':'none';
  if(rebaixoWrap)rebaixoWrap.style.display=cat==='rebaixo'?'':'none';
  if(calhaWrap)calhaWrap.style.display=cat==='calha_umida'?'':'none';
  if(piaDetalhesWrap)piaDetalhesWrap.style.display=cat==='pia_esculpida'?'':'none';
  if(peWrap)peWrap.style.display=cat==='peca_especial'?'':'none';
  if(ACABAMENTO_CATEGORIAS_COM_APLICACAO.includes(cat))renderAcabamentoAplicacoesCheckboxes(_acabamentoAplicacoesTemp);
  if(cat==='pia_esculpida')acabamentoAtualizarCamposPia();
}
function acabamentoAtualizarCamposPia(){
  const modelo=document.getElementById('acabamento-pia-modelo')?.value;
  const campoTaxa=document.getElementById('acabamento-pia-campo-taxa');
  const campoM2=document.getElementById('acabamento-pia-campo-m2');
  const campoUnidade=document.getElementById('acabamento-pia-campo-unidade');
  const campoMetro=document.getElementById('acabamento-pia-campo-metro');
  if(campoTaxa)campoTaxa.style.display=(modelo==='material_fabricacao_taxa'||modelo==='combinado')?'':'none';
  if(campoM2)campoM2.style.display=(modelo==='material_fabricacao_m2'||modelo==='combinado')?'':'none';
  if(campoUnidade)campoUnidade.style.display=(modelo==='unidade'||modelo==='combinado')?'':'none';
  if(campoMetro)campoMetro.style.display=(modelo==='metro_linear'||modelo==='combinado')?'':'none';
}
// Monta o sub-objeto "detalhes" (campos específicos por categoria) a partir do form
// atual. Ver ACABAMENTO_CATEGORIAS_COM_APLICACAO/aplicacoesDisponiveis para o campo
// Aplicação, que é compartilhado entre friso/rebaixo/calha_umida.
function acabamentoMontarDetalhes(categoria){
  if(categoria==='rebaixo')return{tipo:document.getElementById('acabamento-rebaixo-tipo')?.value||'normal'};
  if(categoria==='calha_umida')return{modelo:document.getElementById('acabamento-calha-modelo')?.value.trim()||'',tipoCorte:document.getElementById('acabamento-calha-corte')?.value.trim()||''};
  if(categoria==='pia_esculpida')return{
    modeloPrecificacao:document.getElementById('acabamento-pia-modelo')?.value||'material_fabricacao_taxa',
    taxaFixa:parseMoneyInput(document.getElementById('acabamento-pia-taxa-fixa')),
    precoM2Beneficiamento:parseMoneyInput(document.getElementById('acabamento-pia-preco-m2')),
    precoUnidade:parseMoneyInput(document.getElementById('acabamento-pia-preco-unidade')),
    precoMetroLinear:parseMoneyInput(document.getElementById('acabamento-pia-preco-metro'))
  };
  if(categoria==='peca_especial')return{
    tipo:document.getElementById('acabamento-pe-tipo')?.value||'redonda',
    percentualPerda:parseFloat(document.getElementById('acabamento-pe-perda-pct')?.value)||0,
    custoFabricacaoAdicional:{tipo:document.getElementById('acabamento-pe-fabricacao-tipo')?.value||'fixo',valor:parseMoneyInput(document.getElementById('acabamento-pe-fabricacao-valor'))},
    materialAdicional:{tipo:document.getElementById('acabamento-pe-material-tipo')?.value||'fixo',valor:parseMoneyInput(document.getElementById('acabamento-pe-material-valor'))}
  };
  return{consomeMaterialAdicional:categoria==='friso'&&!!document.getElementById('acabamento-chapa-extra')?.checked};
}
function _renderAcabamentoImagemPreview(){
  const host=document.getElementById('acabamento-imagem-preview');if(!host)return;
  if(!_acabamentoImagemTemp){host.innerHTML='<div class="ecosystem-empty">Nenhuma imagem enviada ainda.</div>';return}
  host.innerHTML=`<div class="material-gallery-item"><button type="button" id="acabamento-img-preview-btn"><div class="material-card-placeholder"><i class="ti ti-photo"></i></div></button><div class="material-gallery-caption"><button class="btn btn-danger btn-sm" onclick="acabamentoRemoverImagem()">Remover</button></div></div>`;
  materialImageDisplayUrl(_acabamentoImagemTemp).then(url=>{const btn=document.getElementById('acabamento-img-preview-btn');if(url&&btn)btn.innerHTML=`<img src="${escapeHtml(url)}" alt="Referência">`});
}
function acabamentoRemoverImagem(){_acabamentoImagemTemp=null;_renderAcabamentoImagemPreview()}
async function acabamentoUploadImagem(){
  if(!await dbxEnsureToken()){toast('Conecte o Dropbox primeiro','error');return;}
  const input=document.createElement('input');
  input.type='file';input.accept='image/jpeg,image/png,image/webp';
  input.onchange=async()=>{
    const file=input.files[0];if(!file)return;
    if(file.size>8*1024*1024){toast('Imagem acima de 8 MB.','error');return}
    const id=document.getElementById('acabamento-id').value||('acab_'+Date.now());
    const imageId='img_'+Date.now()+'_'+Math.random().toString(36).slice(2,6),ext=file.name.split('.').pop()||'jpg';
    const mesAno=new Date().toISOString().slice(0,7);
    const path=`/Catalogo/Acabamentos/${mesAno}/${id}_${imageId}.${ext}`;
    const btn=document.getElementById('acabamento-imagem-btn');
    if(btn){btn.disabled=true;btn.textContent='Enviando...'}
    try{
      await dbxUploadFile(path,file);
      _acabamentoImagemTemp={id:imageId,path,thumbnailPath:path};
      _renderAcabamentoImagemPreview();
      toast('Imagem enviada.');
    }catch(e){toast('Erro no upload: '+e.message,'error')}
    finally{if(btn){btn.disabled=false;btn.innerHTML='<i class="ti ti-photo-plus"></i> Enviar imagem de referência'}}
  };
  input.click();
}
function openAcabamentoForm(id=null){
  document.getElementById('acabamento-id').value=id||'';
  document.getElementById('acabamento-nome').value='';
  document.getElementById('acabamento-categoria').value='rebaixo';
  document.getElementById('acabamento-preco-tipo').value='m2';
  document.getElementById('acabamento-preco-valor').value='';
  document.getElementById('acabamento-chapa-extra').checked=false;
  document.getElementById('acabamento-obs').value='';
  document.getElementById('acabamento-delete-btn').style.display='none';
  document.getElementById('acabamento-rebaixo-tipo').value='normal';
  document.getElementById('acabamento-calha-modelo').value='';
  document.getElementById('acabamento-calha-corte').value='';
  document.getElementById('acabamento-pia-modelo').value='material_fabricacao_taxa';
  document.getElementById('acabamento-pe-tipo').value='redonda';
  document.getElementById('acabamento-pe-perda-pct').value='';
  document.getElementById('acabamento-pe-fabricacao-tipo').value='fixo';
  document.getElementById('acabamento-pe-material-tipo').value='fixo';
  ['acabamento-pia-preco-m2','acabamento-pia-preco-unidade','acabamento-pia-preco-metro','acabamento-pe-fabricacao-valor','acabamento-pe-material-valor'].forEach(fid=>{const el=document.getElementById(fid);if(el)el.value=''});
  // Sugestão inicial de mão de obra pra cuba esculpida (pedido do usuário:
  // "deixa todas elas com custo extra de 500 und"). É só um valor pré-
  // preenchido pra facilitar o primeiro cadastro — cada marmoraria (tenant)
  // continua livre pra ajustar antes de salvar; não é um preço fixado pela
  // plataforma. Só entra num cadastro NOVO (id null); editar um já existente
  // carrega o valor real salvo, sobrescrevendo isso logo abaixo.
  if(!id)setMoneyInputValue(document.getElementById('acabamento-pia-taxa-fixa'),500);
  else{const el=document.getElementById('acabamento-pia-taxa-fixa');if(el)el.value=''}
  _acabamentoImagemTemp=null;
  _acabamentoAplicacoesTemp=[];
  if(id){
    const a=DB.get('acabamentosEspeciais').find(x=>x.id===id);
    if(a){
      document.getElementById('acabamento-nome').value=a.nome||'';
      document.getElementById('acabamento-categoria').value=a.categoria||'rebaixo';
      document.getElementById('acabamento-preco-tipo').value=a.precificacao?.tipo||'m2';
      setMoneyInputValue(document.getElementById('acabamento-preco-valor'),a.precificacao?.valor);
      document.getElementById('acabamento-chapa-extra').checked=!!a.requerChapaExtra;
      document.getElementById('acabamento-obs').value=a.obs||'';
      document.getElementById('acabamento-delete-btn').style.display='';
      _acabamentoAplicacoesTemp=Array.isArray(a.aplicacoesDisponiveis)?a.aplicacoesDisponiveis:[];
      const d=a.detalhes||{};
      if(a.categoria==='rebaixo')document.getElementById('acabamento-rebaixo-tipo').value=d.tipo||'normal';
      if(a.categoria==='calha_umida'){document.getElementById('acabamento-calha-modelo').value=d.modelo||'';document.getElementById('acabamento-calha-corte').value=d.tipoCorte||'';}
      if(a.categoria==='pia_esculpida'){
        document.getElementById('acabamento-pia-modelo').value=d.modeloPrecificacao||'material_fabricacao_taxa';
        setMoneyInputValue(document.getElementById('acabamento-pia-taxa-fixa'),d.taxaFixa);
        setMoneyInputValue(document.getElementById('acabamento-pia-preco-m2'),d.precoM2Beneficiamento);
        setMoneyInputValue(document.getElementById('acabamento-pia-preco-unidade'),d.precoUnidade);
        setMoneyInputValue(document.getElementById('acabamento-pia-preco-metro'),d.precoMetroLinear);
      }
      if(a.categoria==='peca_especial'){
        document.getElementById('acabamento-pe-tipo').value=d.tipo||'redonda';
        document.getElementById('acabamento-pe-perda-pct').value=d.percentualPerda||'';
        document.getElementById('acabamento-pe-fabricacao-tipo').value=d.custoFabricacaoAdicional?.tipo||'fixo';
        setMoneyInputValue(document.getElementById('acabamento-pe-fabricacao-valor'),d.custoFabricacaoAdicional?.valor);
        document.getElementById('acabamento-pe-material-tipo').value=d.materialAdicional?.tipo||'fixo';
        setMoneyInputValue(document.getElementById('acabamento-pe-material-valor'),d.materialAdicional?.valor);
      }
      if(a.imagem)_acabamentoImagemTemp=a.imagem;
    }
  }
  acabamentoAtualizarCamposCategoria();
  _renderAcabamentoImagemPreview();
  openModal('modal-acabamento');
}
async function salvarAcabamento(){
  const categoria=document.getElementById('acabamento-categoria').value;
  const regras=[{id:'acabamento-nome',label:'Nome'}];
  if(categoria!=='pia_esculpida')regras.push({id:'acabamento-preco-valor',label:'Valor cobrado',tipo:'numero_positivo'});
  if(!validarFormulario(regras))return;
  const id=document.getElementById('acabamento-id').value;
  const item={
    id:id||'acab_'+Date.now(),
    nome:document.getElementById('acabamento-nome').value.trim(),
    categoria,
    precificacao:categoria==='pia_esculpida'?null:{tipo:document.getElementById('acabamento-preco-tipo').value,valor:parseMoneyInput(document.getElementById('acabamento-preco-valor'))},
    requerChapaExtra:categoria==='friso'&&document.getElementById('acabamento-chapa-extra').checked,
    aplicacoesDisponiveis:ACABAMENTO_CATEGORIAS_COM_APLICACAO.includes(categoria)?acabamentoAplicacoesSelecionadas():[],
    detalhes:acabamentoMontarDetalhes(categoria),
    obs:document.getElementById('acabamento-obs').value.trim(),
    imagem:_acabamentoImagemTemp,
    updatedAt:new Date().toISOString()
  };
  if(!id)item.createdAt=item.updatedAt;
  const lista=DB.get('acabamentosEspeciais');
  const antes=id?JSON.parse(JSON.stringify(lista.find(x=>x.id===item.id)||null)):null;
  const idx=lista.findIndex(x=>x.id===item.id);
  if(idx>=0)lista[idx]={...lista[idx],...item};else lista.push(item);
  await DB.set('acabamentosEspeciais',lista);
  await auditar(id?'editar':'criar','acabamentosEspeciais',`${id?'Editou':'Cadastrou'} acabamento ${item.nome}`,antes,item);
  closeModal('modal-acabamento');
  renderAcabamentos();
  toast(id?'Acabamento atualizado':'Acabamento cadastrado ✅');
}
async function deleteAcabamento(id){
  if(!id||!await uiConfirm({tone:'danger',eyebrow:'Catálogo de acabamentos',title:'Excluir este acabamento?',impact:'Ele deixará de aparecer para novas peças. Orçamentos que já usam este acabamento mantêm os dados gravados.',confirmLabel:'Excluir do catálogo'}))return;
  const antes=DB.get('acabamentosEspeciais').find(x=>x.id===id);
  await DB.remove('acabamentosEspeciais',id);
  await auditar('excluir','acabamentosEspeciais',`Excluiu acabamento ${antes?.nome||id}`,antes,null);
  closeModal('modal-acabamento');
  renderAcabamentos();
  toast('Acabamento excluído');
}
function acabamentosLimparFiltros(){
  const s=document.getElementById('acabamento-search'),c=document.getElementById('acabamento-filter-categoria');
  if(s)s.value='';if(c)c.value='';
  renderAcabamentos();
}
function renderAcabamentos(){
  const listEl=document.getElementById('acabamentos-list');if(!listEl)return;
  const todos=DB.get('acabamentosEspeciais')||[];
  const busca=(document.getElementById('acabamento-search')?.value||'').toLowerCase().trim();
  const catFiltro=document.getElementById('acabamento-filter-categoria')?.value||'';
  const lista=todos.filter(a=>{
    if(catFiltro&&a.categoria!==catFiltro)return false;
    if(busca&&!String(a.nome||'').toLowerCase().includes(busca))return false;
    return true;
  }).sort((a,b)=>String(a.nome||'').localeCompare(String(b.nome||''),'pt'));
  const summary=document.getElementById('acabamentos-summary');
  if(summary){
    const porCategoria=Object.keys(ACABAMENTO_CATEGORIAS).map(cat=>({cat,n:todos.filter(a=>a.categoria===cat).length}));
    summary.innerHTML=`<div class="card"><label>Total cadastrado</label><div class="val">${todos.length}</div></div>`+porCategoria.map(({cat,n})=>`<div class="card"><label>${escapeHtml(acabamentosCategoriaLabel(cat))}</label><div class="val">${n}</div></div>`).join('');
  }
  if(!lista.length){listEl.innerHTML='<div class="empty"><strong>Nenhum acabamento cadastrado.</strong><br>Cadastre rebaixos, frisos, calhas úmidas, pias esculpidas ou peças especiais para usar nos orçamentos.</div>';return}
  listEl.innerHTML=lista.map(a=>{
    const precoLabel=a.categoria==='pia_esculpida'?(ACABAMENTO_PIA_MODELO_LABELS[a.detalhes?.modeloPrecificacao]||'Cobrança configurável')
      :a.precificacao?.tipo==='item'?`${fmt(a.precificacao.valor)} / item`
      :a.precificacao?.tipo==='metro_linear'?`${fmt(a.precificacao?.valor)} / m linear`
      :`${fmt(a.precificacao?.valor)} / m²`;
    const tipoLabel=a.detalhes?.tipo?` · ${escapeHtml(acabamentoTipoLabel(a.categoria,a.detalhes.tipo))}`:'';
    return `<article class="material-card">
      <button class="material-card-media" onclick="openAcabamentoForm('${escapeHtml(a.id)}')" id="acabamento-media-${escapeHtml(a.id)}"><div class="material-card-placeholder"><i class="ti ti-photo"></i></div></button>
      <div class="material-card-body">
        <h3>${escapeHtml(a.nome||'—')}</h3>
        <div class="material-card-meta">${escapeHtml(acabamentosCategoriaLabel(a.categoria))}${tipoLabel} · ${escapeHtml(precoLabel)}${a.requerChapaExtra?' · <strong style="color:var(--warn)">chapa extra</strong>':''}</div>
        <div class="material-card-footer">
          <span class="material-readiness"></span>
          <button class="btn btn-ghost btn-sm" onclick="openAcabamentoForm('${escapeHtml(a.id)}')">Editar</button>
        </div>
      </div>
    </article>`;
  }).join('');
  lista.forEach(a=>{
    if(!a.imagem)return;
    materialImageDisplayUrl(a.imagem).then(url=>{
      const btn=document.getElementById('acabamento-media-'+a.id);
      if(url&&btn)btn.innerHTML=`<img src="${escapeHtml(url)}" alt="${escapeHtml(a.nome||'')}" loading="lazy" decoding="async">`;
    });
  });
}

